import { Fragment } from 'react'
import { Dialog } from '../Modals/Dialog'
import { tm } from '../tm'
import { ProjectNewsCardDialog } from './CardDialog'
import type { Locales, ProjectUpdate } from '@captaincause/types'

interface DialogAllNewsProps {
  allNews?: ProjectUpdate[]
  close: () => void
  locale: Locales
}

export function DialogAllNews({
  allNews = undefined,
  close,
  locale,
}: DialogAllNewsProps) {
  return (
    <Dialog
      isOpen={!!allNews}
      close={close}
      panelClassName="md:w-[600px] max-h-[80vh] lg:w-[700px]"
      rootNode="__next"
      withCloseButton
    >
      {allNews
        ? allNews.map((news, index) => (
            <Fragment key={news.id}>
              <ProjectNewsCardDialog news={news} locale={locale} />

              <hr
                className={tm(
                  'mt-8 h-px w-full py-4 text-inside',
                  index === allNews.length - 1 && 'hidden',
                )}
              />
            </Fragment>
          ))
        : null}
    </Dialog>
  )
}
